var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 13.1699C7.87037 13.1699 6.13037 11.4399 6.13037 9.29994C6.13037 7.15994 7.87037 5.43994 10.0004 5.43994C12.1304 5.43994 13.8704 7.16994 13.8704 9.30994C13.8704 11.4499 12.1304 13.1699 10.0004 13.1699ZM10.0004 6.93994C8.70037 6.93994 7.63037 7.99994 7.63037 9.30994C7.63037 10.6199 8.69037 11.6799 10.0004 11.6799C11.3104 11.6799 12.3704 10.6199 12.3704 9.30994C12.3704 7.99994 11.3004 6.93994 10.0004 6.93994Z",
    fill: "#F68B1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 21.76C8.52018 21.76 7.03018 21.2 5.87018 20.09C2.92018 17.25 -0.339824 12.72 0.890176 7.33C2.00018 2.44 6.27018 0.25 10.0002 0.25C10.0002 0.25 10.0002 0.25 10.0102 0.25C13.7402 0.25 18.0102 2.44 19.1202 7.34C20.3402 12.73 17.0802 17.25 14.1302 20.09C12.9702 21.2 11.4802 21.76 10.0002 21.76ZM10.0002 1.75C7.09018 1.75 3.35018 3.3 2.36018 7.66C1.28018 12.37 4.24018 16.43 6.92018 19C8.65018 20.67 11.3602 20.67 13.0902 19C15.7602 16.43 18.7202 12.37 17.6602 7.66C16.6602 3.3 12.9102 1.75 10.0002 1.75Z",
    fill: "#F68B1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.c3dc54655133ccc70efeabf35bcac99a.svg";
export { ForwardRef as ReactComponent };